<div class="modal-header" data-test-id="organize-bookings-modal-header">
  <h2 class="modal-title">{{ title$ | async }}</h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>
<div class="modal-body" data-test-id="organize-bookings-modal-body">
  <form [formGroup]="form" (ngSubmit)="onFormSubmit()" #formRef="ngForm">
    <h3
      class="h5"
      [ngClass]="{
        'table-danger': currentParticipantCount > maxNumOfParticipants,
        'table-success':
          currentParticipantCount < maxNumOfParticipants &&
          currentParticipantCount > 0,
        'table-primary': currentParticipantCount == 0
      }"
    >
      {{ 'organizeBookingsModule.currentParticipants' | translate }}:
      <span class="ms-2">
        {{ currentParticipantCount }}
      </span>
    </h3>

    <div class="mb-4" *ngIf="currentParticipantCount > 0">
      <label class="form-label">
        {{ 'saleModule.wouldYouLikeToMoveParticipants' | translate }}
      </label>

      <select
        formControlName="moveParticipants"
        class="form-select"
        [attr.aria-invalid]="
          form.controls.moveParticipants.dirty &&
          form.controls.moveParticipants.invalid
            ? 'true'
            : null
        "
      >
        <option [value]="0">
          {{ 'organizeBookingsModule.wantToAdjustParticipants' | translate }}
        </option>
        <option [value]="1">
          {{ 'organizeBookingsModule.wantToMoveParticipants' | translate }}
        </option>
      </select>
    </div>

    <ng-container
      *ngIf="form.controls.moveParticipants.value == 0; else movePaticipants"
    >
      <div class="mb-4">
        <label class="form-label">
          {{ 'organizeBookingsModule.newParticipants' | translate }}
          <small
            *ngIf="maxNumOfParticipantsToShow > 0"
            [ngClass]="{
              'text-danger':
                form.controls.participantCount.dirty &&
                form.controls.participantCount.invalid
            }"
          >
            ({{ 'general.max' | translate | lowercase }}:
            {{ maxNumOfParticipantsToShow }})
          </small>
        </label>

        <input
          data-test-id="organize-bookings-participant-count-input"
          type="number"
          class="form-control"
          placeholder="1"
          min="0"
          step="1"
          formControlName="participantCount"
          [attr.aria-invalid]="
            form.controls.participantCount.dirty &&
            form.controls.participantCount.invalid
              ? 'true'
              : null
          "
        />
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'organizeBookingsModule.datesToApply' | translate }}
        </label>

        <select
          data-test-id="organize-bookings-apply-dates-select"
          formControlName="applyForWholeStay"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.applyForWholeStay.dirty &&
            form.controls.applyForWholeStay.invalid
              ? 'true'
              : null
          "
        >
          <option
            *ngFor="let selectDatesOption of selectDatesOption"
            [value]="selectDatesOption.id"
          >
            {{ selectDatesOption['title_en'] }}
          </option>
        </select>
      </div>

      <div
        class="mb-4"
        [hidden]="
          form.value.applyForWholeStay != selectDateOptions.FOR_SELECTED_DAYS
        "
      >
        <label class="form-label">
          {{ 'organizeBookingsModule.datesToApply' | translate }}
        </label>
        <ng-select
          class="d-block"
          [items]="selectableDates"
          [multiple]="true"
          [closeOnSelect]="false"
          formControlName="selectedDates"
          bindLabel="longDate"
          bindValue="date"
          [clearSearchOnAdd]="true"
        >
        </ng-select>
      </div>
    </ng-container>

    <ng-template #movePaticipants>
      <div class="mb-4">
        <label class="form-label">
          {{ 'saleModule.selectProductToMove' | translate }}
        </label>

        <select
          formControlName="targetResourceId"
          class="form-select"
          [attr.aria-invalid]="
            form.controls.targetResourceId.dirty &&
            form.controls.targetResourceId.invalid
              ? 'true'
              : null
          "
        >
          <option
            *ngFor="let product of availableResourcesToMoveInto"
            [value]="product.id"
          >
            {{ product.description }}
          </option>
        </select>
      </div>

      <div class="mb-4">
        <label class="form-label">
          {{ 'saleModule.howManyParticipantsToMove' | translate }}
          <small
            *ngIf="(getMaxNumOfParticipants() | async) > 0"
            [ngClass]="{
              'text-danger':
                form.controls.numberOfParticipantsToMove.dirty &&
                form.controls.numberOfParticipantsToMove.invalid
            }"
          >
            ({{ 'general.max' | translate | lowercase }}:
            {{ getMaxNumOfParticipants() | async }})
          </small>
        </label>

        <input
          data-test-id="organize-bookings-number-of-participants-to-move-input"
          type="number"
          class="form-control"
          placeholder="1"
          min="0"
          step="1"
          formControlName="numberOfParticipantsToMove"
          [attr.aria-invalid]="
            form.controls.numberOfParticipantsToMove.dirty &&
            form.controls.numberOfParticipantsToMove.invalid
              ? 'true'
              : null
          "
        />
      </div>
    </ng-template>

    <div class="form-footer">
      <button
        data-test-id="organize-bookings-save-button"
        class="btn btn-primary"
        type="submit"
        [disabled]="!form.valid || isSaving"
      >
        <span *ngIf="!isSaving; else loading">
          {{ 'general.save' | translate }}
        </span>
        <ng-template #loading>
          <div
            class="spinner-border spinner-border-sm"
            role="status"
            attr.aria-label="{{ 'general.loading' | translate }}"
          >
          </div>
        </ng-template>
      </button>
    </div>
  </form>

  <ng-container *ngIf="!isSaving">
    <div class="d-flex justify-content-between mt-4 align-items-center">
      <h3 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="collapsedTable"
        >
          <span class="fs-3">{{
            'organizeBookingsModule.reviewChanges' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h3>
    </div>

    <div *ngIf="!isCollapsed" id="collapsedTable">
      <table class="table table-sm">
        <thead class="text-dark">
          <th scope="col">{{ 'general.date' | translate }}</th>
          <th scope="col">{{ 'general.change' | translate }}</th>
        </thead>
        <tbody>
          <tr
            *ngFor="let change of getChanges()"
            [ngClass]="{
              'table-primary': change.action == changeActions.CREATE,
              'table-success': change.action == changeActions.ADD,
              'table-danger': change.action == changeActions.DELETE
            }"
          >
            <td>{{ change.date }}</td>
            <td>{{ change.change }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
